// removed by extract-text-webpack-plugin
module.exports = {"root":"root__DiIfB","snug":"snug__1EkJD"};


//////////////////
// WEBPACK FOOTER
// ./components/Container/style.css
// module id = 8C0a
// module chunks = 0